import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseGetWithoutParam,
} from 'services/base-services/baseService';

const baseURL = `${API2_HOST}/sp-customers`;
const getCustomers = async () => {
  return await baseGetWithoutParam(baseURL);
};


export { getCustomers };
